declare namespace $ {

	type $mol_view__sub_bog_music_nav_item_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_music_nav_item extends $mol_view {
		click( next?: any ): any
		Label( ): $mol_view
		label( ): string
		active( ): string
		Icon( ): $mol_view
		attr( ): ({ 
			'bog_music_nav_active': ReturnType< $bog_music_nav_item['active'] >,
		})  & ReturnType< $mol_view['attr'] >
		event( ): ({ 
			click( next?: ReturnType< $bog_music_nav_item['click'] > ): ReturnType< $bog_music_nav_item['click'] >,
		})  & ReturnType< $mol_view['event'] >
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=item.view.tree.d.ts.map